const resultsWorkspace = {
  analysis: {
    errors: {
      conflict: '分析の入力内容が変更されました。最新の内容を読み込んでから、分析待ちの行を再度分析してください。',
      validation: '分析リクエストが拒否されました。分析待ちの行とレビュー要件を確認し、最新の内容を読み込んでください。',
      unexpected: '分析結果を確認できませんでした。最新の内容を読み込んでから、もう一度お試しください。',
      unavailable: {
        temporarilyUnavailable: '一時的に分析できませんでした。再試行してください。',
        serverError: 'サーバーエラーで分析結果を確認できませんでした。最新の結果を確認するには、再読み込みまたは再試行してください。',
        network: '通信エラーで分析結果を確認できませんでした。最新の結果を確認するには、再読み込みまたは再試行してください。',
        flagOff: 'この環境では分析が無効になっています。結果は引き続き閲覧できます。',
        flagUnconfirmed: '分析が有効か確認できませんでした。最新の内容を読み込んでから、もう一度お試しください。',
      },
    },
    pending: '分析待ち',
    failure_mode: '故障モードを生成',
    countermeasure: '対策案を生成',
    analyze_one: '分析待ちの{{count}}行を分析',
    analyze_other: '分析待ちの{{count}}行を分析',
    running: '分析中…',
    guidance: '分析待ちの行を確認・採用してから実行してください。採用済み・編集済みの結果は保持され、新しい候補は確認が必要です。',
    saveTitle: '保存後に再分析しますか？',
    saveDescription: '再分析を選ぶと、この行は分析待ちになります。分析が成功するまで既存の結果は保持されます。「現在の結果を保持」は、再分析を依頼せず編集内容を保存します。',
    keep: '現在の結果を保持',
    reanalyze: '再分析する',
    cancel: 'キャンセル',
    completed: '分析が完了しました。新しい候補を確認してください。',
  },
  title: '分析結果',
  kinds: {
    design_change: '変更点',
    failure_mode: '故障モード',
    countermeasure: '対策案',
  },
  view: {
    label: '表示形式',
    list: '一覧',
    board: 'ボード',
  },
  board: {
    show: {
      design_change: '変更点 {{count}}件をボードで表示',
      failure_mode: '故障モード {{count}}件をボードで表示',
      countermeasure: '対策案 {{count}}件をボードで表示',
    },
  },
  overview: {
    unlinked: '起点の行が見つからない項目',
    noFailureModes: '表示中の故障モードはありません',
    noCountermeasures: '表示中の対策案はありません',
  },
  visibility: {
    label: '表示範囲',
    active: '有効な行',
    withRejected: '非採用を含む',
    all: '旧版を含むすべて',
  },
  counts: {
    label: '{{kind}}の件数',
    hiddenByAncestor: '上位が非採用・旧版',
  },
  tags: {
    changePoint: '関連する変更点 {{code}}',
    failureMode: '対象の故障モード {{code}}',
  },
  columns: {
    code: 'No.',
    status: '状態',
    content: '内容',
    originChange: '起点となる変更点',
    originFailure: '起点となる故障モード',
    type: 'タイプ',
    severity: '重要度',
  },
  openDetail: '{{code}} の詳細を開く',
  emptyKind: {
    design_change: 'この表示範囲に該当する変更点はありません',
    failure_mode: 'この表示範囲に該当する故障モードはありません',
    countermeasure: 'この表示範囲に該当する対策案はありません',
  },
  emptySession: 'まだ分析結果がありません',
  load: {
    loading: '分析結果を読み込んでいます',
    missing: 'この分析は見つかりません。削除されたか、URLが誤っている可能性があります。',
    forbidden: 'この分析を表示する権限がありません。',
    signedOut: 'ログインの有効期限が切れました。再度ログインしてください。',
    unavailable: '分析結果を読み込めませんでした。しばらくしてから再試行してください。',
    unexpected: '分析結果を表示できませんでした。',
    retry: '再読み込み',
    refreshFailed: '最新の分析結果を読み込めませんでした。表示中の内容は古い可能性があります。',
  },
  fields: {
    category: '区分',
    item_name: '対象部品・機能',
    old_specification: '旧仕様',
    new_specification: '新仕様',
    change_description: '変更内容',
    failure_description: '故障モード',
    causal_claims: '因果の推論',
    failure_cause: '原因',
    failure_effect: '影響',
    severity_score: '重要度',
    countermeasure_requirement: '対策の要否',
    countermeasure_not_required_reason: '対策不要の理由',
    description: '対策内容',
    countermeasure_type: '対策の種類',
    target_cause: '対象とする原因',
    mechanism: '効く仕組み',
    verification_method: '検証方法',
    acceptance_criteria: '合格基準',
  },
  options: {
    countermeasure_requirement: { pending: '未判断', required: '必要', not_required: '不要' },
    countermeasure_type: { prevention: '予防', detection: '検出', mitigation: '軽減' },
  },
  listSeparator: '、',
  severityOption: '{{label}}（{{score}}）',
  detail: {
    title: {
      design_change: '変更点 {{code}}',
      failure_mode: '故障モード {{code}}',
      countermeasure: '対策案 {{code}}',
    },
    description: '内容を確認し、必要なら編集して保存してから、採用・非採用などを判断します。',
    descriptionEditOnly: '内容を確認し、必要なら編集して保存します。この行はまだ判断できません。',
    descriptionDecideOnly: '内容を確認し、採用・非採用などを判断します。ここでは編集できません。',
    descriptionReadOnly: '内容を確認できます。ここでは編集も判断もできません。',
    savedNotShown: '記録しましたが、この画面に反映できませんでした。最新の内容を読み込んでください。',
    reloaded: '最新の内容を読み込みました。他の人が変更した項目に印を付けています。確認してから、もう一度保存してください。',
    reloadedOther: '最新の内容を読み込みました。この画面の入力欄以外（状態や評価など）が他の人によって変更されています。内容を確認してから続けてください。',
    reloadedUnchanged: '最新の内容を読み込みました。この項目の内容は変わっていません。もう一度操作してください。',
    changedByOthers: '他の人が更新',
    claimsOriginUnrecorded: 'この推論の作成元は記録されていません。',
    memory: '設計判断メモリ',
    originChange: '起点となった変更点',
    originFailure: '起点となる故障モード',
    plannedMeasures: '想定される対策案',
    relatedFailures: '関連する故障モード',
    none: 'なし',
    causalEmpty: 'AIが組み立てた因果仮説はありません',
    relatedKnowledge: '関連知識サマリー',
    sourcesEmpty: '関連する資料はありません',
    page: '{{page}}ページ',
    openDocument: '文書で開く',
    openDocumentLabel: '「{{title}}」を文書で開く',
    openExternal: '元のページを開く',
    openExternalLabel: '「{{title}}」の元のページを開く（新しいタブ）',
    preview: 'プレビュー',
    previewLabel: '「{{title}}」をプレビュー',
    previewLoading: '文書を読み込んでいます…',
    previewNotFound: '見つからないか、アクセス権がありません',
    previewLoadFailed: '文書を読み込めませんでした。通信状況を確認して、もう一度お試しください。',
    previewRetry: '再試行',
    save: '保存',
    saving: '保存中…',
    saved: '保存しました',
    decided: '判断を記録しました',
    close: '閉じる',
    decisionLabel: '判断',
    saveFirst: '判断する前に、編集内容を保存してください。',
    reconfirm: '上位の変更を確認したうえで採用します',
    decisions: { adopt: '採用', reject: '非採用', defer: '保留', needsChecking: '要確認' },
    blocked: {
      parentNotAdopted: '上位の行が採用されていないため、まだ判断できません。',
      historical: '旧版の行は変更できません。',
      flagOff: 'この環境では編集できません。',
      integrityHold: '抽出内容の確認が終わるまで採用できません。',
      missingRequiredContent: '採用するには次の項目を入力してください: {{fields}}',
      kindNotAiEditable: 'この行はAIで編集できません。',
      countermeasureNotRequired: '対策が不要とされた故障モードの対策案です。',
    },
  },
  claims: {
    claim: '推論 {{n}}',
    evidenceLevel: '推論 {{n}} の根拠の強さ',
    evidence: '推論 {{n}} の根拠',
    level: { direct: '直接根拠', supported: '補強根拠', assumption: '仮説' },
    add: '推論を追加',
    remove: '推論 {{n}} を削除',
    moveUp: '推論 {{n}} を上へ',
    moveDown: '推論 {{n}} を下へ',
    count: '{{n}} / {{max}}',
    empty: '推論はまだありません。',
    limitReached: '推論は{{max}}件までです。',
    errors: {
      blank: '推論を入力してください。',
      level: '根拠の強さを選んでください。',
      tooLong: '{{max}}文字以内で入力してください。',
      tooMany: '推論は{{max}}件までです。保存するには減らしてください。',
    },
  },
  discard: {
    title: '保存していない変更があります',
    description: '閉じると、保存していない編集内容は失われます。',
    keep: '編集を続ける',
    discard: '破棄して閉じる',
  },
  create: {
    title: { design_change: '変更点を追加', failure_mode: '故障モードを追加', countermeasure: '対策案を追加' },
    description: '内容を入力して追加します。',
    parentPlaceholder: '選択してください',
    noParent: '変更点には起点となる行はありません。',
    noParentAvailable: {
      failure_mode: '追加できる起点の変更点がありません。', countermeasure: '追加できる起点の故障モードがありません。',
    },
    add: '追加',
    adding: '追加中…',
    missing: 'この分析は見つかりません。削除された可能性があります。',
    reloaded: '最新の内容を読み込みました。内容と起点を確認してから、もう一度追加してください。',
    problems: {
      missingParent: { failure_mode: '起点となる変更点を選んでください。', countermeasure: '起点となる故障モードを選んでください。' },
      missingItemName: { design_change: '対象部品・機能を入力してください。' },
      missingDescription: {
        design_change: '変更内容を入力してください。', failure_mode: '故障モードを入力してください。', countermeasure: '対策内容を入力してください。',
      },
      invalidClaims: '因果の推論の内容を確認してください。',
    },
  },
  errors: {
    conflict: '他の操作で内容が更新されました。最新の内容を読み込んでから、もう一度保存してください。編集内容は残っています。',
    conflictKept: '他の操作で内容が更新されました。編集内容は残っています。',
    reload: '最新の内容を読み込む',
    reloadFailed: '最新の内容を読み込めませんでした。編集内容は残っています。もう一度お試しください。',
    stalePreview: 'AIの提案を作った後で内容が更新されました。提案を作り直してください。',
    validation: '入力内容を保存できませんでした。内容を確認してください。編集内容は残っています。',
    missing: 'この行は見つかりません。削除された可能性があります。',
    unexpected: '保存できませんでした。編集内容は残っています。',
    retry: '再試行',
    unavailable: {
      temporarilyUnavailable: '一時的に保存できませんでした。編集内容は残っています。再試行してください。',
      serverError: 'サーバーエラーで保存できませんでした。編集内容は残っています。再試行してください。',
      network: '通信エラーで保存できませんでした。編集内容は残っています。再試行してください。',
      aiFailed: 'AIの処理に失敗しました。再試行してください。',
      flagOff: 'この環境では編集が無効になっています。編集内容は残っています。',
      flagUnconfirmed: '保存できませんでした。編集が有効か確認できませんでした。',
      forbidden: 'この操作を行う権限がありません。',
      signedOut: 'ログインの有効期限が切れました。再度ログインしてください。',
    },
  },
  editing: {
    checking: '編集できるかを確認しています。確認が終わるまでは閲覧のみです。',
    unavailable: '編集できるかを確認できませんでした。閲覧のみ表示しています。ページを再読み込みしてください。',
  },
  readOnly: 'この環境では分析結果の編集が有効になっていないため、閲覧のみできます。',
  status: {
    adopted: '採用',
    notAdopted: '非採用',
    onHold: '保留',
    needsChecking: '要確認',
    unreviewed: '未レビュー',
    historical: '旧版',
  },
  severity: {
    critical: '重大',
    high: '高',
    medium: '中',
    low: '低',
    unset: '未設定',
  },
  needsRecheck: '要再確認',
  scoreReset: {
    warning: 'この変更を保存すると、レビュー済みのRPNは暫定に戻り、再レビューが必要になります。',
    acknowledge: 'RPNが暫定に戻ることを確認しました',
  },
  aiCausalHypothesis: 'AIが組み立てた因果仮説',
  activeRows: '表示中: {{count}}件',
  exportAllRows: 'Excel出力（全レビュー状態）: {{count}}件',
};
export default resultsWorkspace;
